var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"student-avatar",style:(_vm.avatarStyle)},[(_vm.src && !_vm.loadFailed)?_c('img',{attrs:{"src":_vm.src,"alt":""},on:{"error":function($event){_vm.loadFailed = true}}}):_c('span',{staticClass:"student-avatar__text",class:`student-avatar__text--${_vm.colorIndex}`},[_vm._v(_vm._s(_vm.avatarName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }